/* eslint-disable compat/compat */
class ProductBis extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.listeners.add(this.els.form.element, 'submit', (e) => {
      e.preventDefault()
      this.onFormSubmission()
    })
  }

  setupListeners () {
    super.setupListeners()

    this.onOptionChanged = this.onOptionChanged.bind(this)

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PRODUCT.OPTION_CHANGED,
      this.onOptionChanged,
    )
  }

  onFormSubmission () {
    const variantId = this.els.form.element.dataset.variantId

    const emailAddress = this.els.email.element.value

    this.backInStockSubscribe(variantId, emailAddress)
  }

  async backInStockSubscribe (variantId, emailAddress) {
    const payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: `${emailAddress}`,
              },
            },
          },
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${variantId}`,
            },
          },
        },
      },
    }

    const options = {
      method: 'POST',
      headers: {
        accept: 'application/vnd.api+json',
        revision: window.theme.klaviyo.apiVersion,
        'content-type': 'application/vnd.api+json',
      },
      body: JSON.stringify(payload),
    }

    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${window.theme.klaviyo.apiKey}`,
        options,
      )

      if (response.status === 202) {
        this.showBackInStockSuccess()
      } else {
        console.error(response)
      }
    } catch (error) {
      console.error('An error occurred during the fetch operation:', error)
    }
  }

  showBackInStockSuccess () {
    this.els.success.element.setAttribute('aria-hidden', false)
    this.els.content.element.setAttribute('aria-hidden', true)
  }

  onOptionChanged () {
    this.els.success.element.setAttribute('aria-hidden', true)
    this.els.content.element.setAttribute('aria-hidden', false)
  }
}

if (!customElements.get('product-bis')) {
  customElements.define('product-bis', ProductBis)
}
